import { render, staticRenderFns } from "./subscriptions.vue?vue&type=template&id=70cd80c6&"
import script from "./subscriptions.vue?vue&type=script&lang=js&"
export * from "./subscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports